import { Socket } from "socket.io-client";
import { useEffect, useRef } from "react";
import { toast } from "sonner";

import { createSocket } from "@/socket-client";
import { useAuth } from "@/lib/use-auth";
import { MdClose } from "react-icons/md";

export const AdminSocketProvider = () => {
  const { data, isPending } = useAuth();

  const socketRef = useRef<Socket | null>(null);

  // const [open, setOpen] = useState(true);

  useEffect(() => {
    if (!isPending && data?.user?._id) {
      socketRef.current = createSocket(data?.user?._id as string);

      socketRef.current.on("connect", () => {
        console.log("Connected to the server");
      });

      socketRef.current.on("notification", (data) => {
        // console.log("Admin Notification received:", data);
        // toast("Bhai sahab");

        toast.custom(
          (t) => (
            <div className="p-4 w-[356px] rounded-md bg-primary text-primary-foreground shadow-md">
              <button
                onClick={() => toast.dismiss(t)}
                className="absolute right-2 top-2"
              >
                <MdClose className="w-4 h-4" />
              </button>
              <h1
                className="font-semibold"
                dangerouslySetInnerHTML={{
                  __html: data?.article,
                }}
              ></h1>
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.title,
                }}
              ></div>
            </div>
          ),
          {
            duration: 50000,
          }
        );
      });

      socketRef.current.on("disconnect", () => {
        console.log("Disconnected from the server");
      });

      socketRef.current.on("ncount", (data) => {
        console.log("ncount received:", data);
      });

      return () => {
        // Clean up socket event listeners when component unmounts
        if (socketRef.current) {
          socketRef.current.off("connect");
          socketRef.current.off("notification");
          socketRef.current.off("ncount");
          socketRef.current.off("disconnect");
        }
      };
    }
  }, [data, isPending]);

  return <></>;
};
